import { connect } from 'react-redux';
import ImageViewer from './ImageViewer';
import { closeImageViewer } from '../../actions/common';

// Maps the state of the store to a set of props that will provide the presentational component with part of the state
const mapStateToProps = state => ({
  imageViewer: state.imageViewer,
});

// Maps the action creators to a set of props that will be passed as functions to the presentational component
const mapDispatchToProps = {
  onCloseImageViewer: closeImageViewer,
};

// This is a container component. It owns the state of the ActiveChat presentational component
const ImageViewerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageViewer);

export default ImageViewerContainer;
